import { useState, useEffect } from 'react';
import { authApi, UserDto, UpdateUserDto, ChangePasswordDto } from '../services/api';

export const useUserProfile = (userId: string) => {
  const [user, setUser] = useState<UserDto | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [updating, setUpdating] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);

  // Cargar datos del usuario
  const loadUser = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('accessToken');
      if (!token) {
        throw new Error('No access token found');
      }
      const userData = await authApi.getUserById(userId, token);
      setUser(userData);
    } catch (err: any) {
      setError(err.message || 'Error al cargar el usuario');
      console.error('Error loading user:', err);
    } finally {
      setLoading(false);
    }
  };

  // Actualizar información del usuario
  const updateProfile = async (data: UpdateUserDto): Promise<boolean> => {
    try {
      setUpdating(true);
      setError(null);
      const updatedUser = await authApi.updateUser(userId, data);
      setUser(updatedUser);
      
      // Update localStorage if this is the current user
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const currentUser = JSON.parse(storedUser);
        if (currentUser.id === userId) {
          localStorage.setItem('user', JSON.stringify(updatedUser));
        }
      }
      
      return true;
    } catch (err: any) {
      setError(err.message || 'Error al actualizar el perfil');
      console.error('Error updating profile:', err);
      return false;
    } finally {
      setUpdating(false);
    }
  };

  // Cambiar contraseña
  const changePassword = async (data: ChangePasswordDto): Promise<boolean> => {
    try {
      setChangingPassword(true);
      setError(null);
      await authApi.changePassword(userId, data);
      return true;
    } catch (err: any) {
      setError(err.message || 'Error al cambiar la contraseña');
      console.error('Error changing password:', err);
      return false;
    } finally {
      setChangingPassword(false);
    }
  };

  // Cargar usuario al montar el componente
  useEffect(() => {
    loadUser();
  }, [userId]);

  return {
    user,
    loading,
    error,
    updating,
    changingPassword,
    updateProfile,
    changePassword,
    reload: loadUser,
  };
};
